import type { EntryPointComponent } from 'react-relay';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { workflowBuilderProvisioningResource } from '@jira/router-resources__admin-pages-workflows-workflow-builder-provisioning/src/useWorkflowBuilderProvisioning.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@jira/navigation-apps__horizontal-nav-selector/src/constants.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsServicedeskIssuetypesWorkflowRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskIssuetypesWorkflowRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { Route } from '@atlassian/react-resource-router';
import { LazyIssueTypeSettings } from './ui/issue-type/index.tsx';
import WorkflowNavigationPage from './ui/workflow-navigation/index.tsx';

const getWorkflowBuilderProvisioningResources = () => [workflowBuilderProvisioningResource];

const projectSettingsServicedeskIssuetypesWorkflowPageEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-project-settings-workflow-navigation", jiraSpaEntry: "async-project-settings-workflow-navigation" */ '@jira/spa-apps__project-settings-workflow-navigation/src/WorkflowNavigationPage.tsx',
			{ entryFsSsrLiftImportToModule: false },
		),
		getPreloadProps: () => ({}),
	},
});

export const projectSettingsServicedeskIssuetypesWorkflowRouteEntry: Route = createEntry(
	projectSettingsServicedeskIssuetypesWorkflowRoute,
	() => ({
		group: 'project-settings-servicedesk',

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_2') ? undefined : WorkflowNavigationPage,

		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_2')
				? projectSettingsServicedeskIssuetypesWorkflowPageEntryPoint
				: undefined,
		layout: serviceProjectLayout,

		navigation: {
			horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			...getWorkflowBuilderProvisioningResources(),
			getConsolidationStateResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyIssueTypeSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
